// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3E_92","itemA":"Write_itemA__3k107","itemB":"Write_itemB__3_7Tn","itemC":"Write_itemC__1uk8K","itemD":"Write_itemD__3nwDk"};